import { useState, useEffect, useCallback } from "react";
import { fetchCategories } from "../services/fetchCategories";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  const loadCategories = useCallback(async () => {
    setLoading(true);
    try {
      const subtopic =
        breadcrumbs.find((item) => item.path === "/categories")?.id || null;

      const data = await fetchCategories(auth.token, subtopic);

      if (data.status === 200) {
        const fnldata = data.data.map((category) => ({
          id: category.id,
          name: category.title,
          description: category.description,
          image: `${process.env.REACT_APP_PUBLIC_API_URL}${category.thumbnail}`,
          valueid: category.source_id,
          value: category.source,
          type: category.type,
          ttl_time: category.ttl_time,
          seen_time: category.seen_time,
          is_completed: category.is_completed,
          intro_audio:
            `${process.env.REACT_APP_PUBLIC_API_URL}${category?.intro_audio}` ||
            null,
          completion_audio:
            `${process.env.REACT_APP_PUBLIC_API_URL}${category?.completion_audio}` ||
            null,
        }));

        setCategories(fnldata);
        return fnldata; // ✅ return fetched list
      } else if (data.status === 400) {
        setCommonWarning(data.message);
        return []; // return empty if error
      } else if (data.status === 401) {
        navigate("/login");
        return []; // return empty if unauthorized
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      return []; // catch safety
    } finally {
      setLoading(false);
    }
  }, [auth.token, breadcrumbs, setCommonWarning]);

  // Initial load on mount
  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  const checkForLoadCtaegories = async () => {
    try {
      const subtopic =
        breadcrumbs.find((item) => item.path === "/categories")?.id || null;

      const data = await fetchCategories(auth.token, subtopic);

      if (data.status === 200) {
        const fnldata = data.data.map((category) => ({
          id: category.id,
          name: category.title,
          description: category.description,
          image: `${process.env.REACT_APP_PUBLIC_API_URL}${category.thumbnail}`,
          valueid: category.source_id,
          value: category.source,
          type: category.type,
          ttl_time: category.ttl_time,
          seen_time: category.seen_time,
          is_completed: category.is_completed,
          intro_audio:
            `${process.env.REACT_APP_PUBLIC_API_URL}${category?.intro_audio}` ||
            null,
          completion_audio:
            `${process.env.REACT_APP_PUBLIC_API_URL}${category?.completion_audio}` ||
            null,
        }));

        return fnldata; // ✅ return fetched list
      } else if (data.status === 400) {
        setCommonWarning(data.message);
        return []; // return empty if error
      } else if (data.status === 401) {
        navigate("/login");
        return []; // return empty if unauthorized
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      return []; // catch safety
    } finally {
      setLoading(false);
    }
  };

  // ✅ expose all
  return [categories, loading, loadCategories, checkForLoadCtaegories];
}

export default useFetchCategories;
